
import React, { useEffect, useState } from 'react';
import { TextField, FormControl, InputLabel, Select, MenuItem, Grid, Paper, useMediaQuery, Button, FormHelperText } from '@mui/material';
import styled, { inputStyles } from '../../Utils/inputChanges';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSingleSchool, updateSchoolEntry } from '../../Store/PHPSlice/School';
import { useParams } from 'react-router-dom';


const SchoolEdit = () => {
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        schoolId: parseInt(Id),
        schoolNm: '',
        adrs: '',
        contact: '',
        userId: userdata?.ID
    });
    const [errors, setErrors] = useState({});
    const dispatch = useDispatch();
    const singleSchool = useSelector((state) => state.SchoolData.singleSchool || { data: [] });
    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement
    useEffect(() => {
        dispatch(fetchSingleSchool(Id))
    }, [dispatch]);
    useEffect(()=>{
        if(singleSchool.data.length>0){
            const item = singleSchool.data[0];
            setFormData({
                ...formData,
                schoolNm: item.schoolNm,
                contact: item.contact,
                adrs: item.adrs,
            });
        }
    },[singleSchool]);

    if (!singleSchool) {
        return <h1>Loading...</h1>
    }
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };


 
    const handleSubmit = (event) => {
        event.preventDefault();
        // console.log(formData);
        // Validate department name
        // if (!formData.rackNm.trim()) {
        //     setErrors({ rackNm: 'Rack Name is required' });
        //     return;
        // }

        dispatch(updateSchoolEntry(formData))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                alert("School Updated");
                window.close();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };






    return (
        <>
            <div style={{ margin: '1%' }}>
                <h2>School Edit</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>
                            <Grid container spacing={2}>

                                {[
                                    { label: 'School Name', name: 'schoolNm' },
                                    { label: 'Contact', name: 'contact' },
                                    { label: 'Address', name: 'adrs' },

                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '35%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>

                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name]}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input }}
                                                        sx={inputStyles}
                                                    />

                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit}>Submit</Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>


            </div>
        </>
    );
}

export default SchoolEdit;
